import { LoadingComponent } from '../loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { CompanyTypeService } from '@services/_iam/company-type.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, LoadingComponent],
  selector: 'app-pay-bill',
  templateUrl: './pay-bill.component.html',
})
export class PayBillComponent implements OnInit,AfterViewInit {
  paybill_link: string;
  accountId: any;
  policyNumber: any;
  xmlBody: any;
  @ViewChild('form') form: ElementRef;
  company: any;
  minAmount: string;
  state: string;
  companyId: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private companyTypeService: CompanyTypeService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param: Params) => {
      const xmlParam =  atob(decodeURIComponent(param['a'])).split("|");
      this.xmlBody = xmlParam[0];
      if (xmlParam.length>3){
        this.company = {
          "companyId": xmlParam[4],
          "companyName": xmlParam[1]
        };
        this.minAmount = xmlParam[2];
        this.state = xmlParam[3];
        } else if (xmlParam.length>1){
        this.company = xmlParam[1];
        this.minAmount = xmlParam[2];
      }
      this.policyNumber = atob(decodeURIComponent(param['b']));
    });
    this.paybill_link = environment.paybill_link;
  }

  ngAfterViewInit() {
    this.submitForm();
  }

  submitForm() {
    const mapForm = document.createElement('form');
    mapForm.setAttribute('style', 'display: none');
    mapForm.method = 'POST';
    mapForm.action = this.getPayBillLink();

    const mapInput = document.createElement('input');
    mapInput.setAttribute('type', 'text');
    mapInput.setAttribute('name', 'txtMiscellaneous');
    mapInput.setAttribute('value', this.xmlBody);
    mapForm.appendChild(mapInput);

    if (this.getPayBillSource()!=''){
    const mapInput2 = document.createElement('input');
    mapInput2.setAttribute('type', 'text');
    mapInput2.setAttribute('name', 'txtAcctNumber');
    mapInput2.setAttribute('value', this.policyNumber);
    mapForm.appendChild(mapInput2);
    }

    const mapInput3 = document.createElement('input');
    mapInput3.setAttribute('type', 'text');
    mapInput3.setAttribute('name', 'txtSource');
    mapInput3.setAttribute('value', this.getPayBillSource());
    mapForm.appendChild(mapInput3);

    document.body.appendChild(mapForm);
    mapForm.submit();
  }

  getPayBillLink(){
    return this.companyTypeService.getPayBill(this.state, this.company, this.policyNumber).url
  }

  getPayBillSource(){
    return this.companyTypeService.getPayBill(this.state, this.company, this.policyNumber).source
  }
}
